export default __webpack_public_path__ + "static/media/new-resume.166d0e87.svg";